import AuthService from 'services/AuthService'

export default {
    transform() {
        return (data) => this.transformData(JSON.parse(data))
    },

    transformData(response) {
        return AuthService.getUserLocations().map((item) => ({
            facilityServiceTypesSubgroups:
                response.find((el) => item.id === el.practiceLocationId)?.facilityServiceTypesSubgroups || [],
            locationName: item.name,
            practiceId: item.practiceId,
            practiceLocationId: item.id || 'main',
        }))
    },
}
